import { ENDPOINT, RELATIONSHIP, RELATIONSHIP_FIELD } from "../utils/constants";
import { request } from "../utils/request";
import { getCurrentUserId, isSignedIn } from "../utils/util";

export const getBadgeByQuizId = async (quizId) => {
  if(isSignedIn()) {
    const data = await request({
      url: `${ENDPOINT.QUIZZES}/${quizId}/${RELATIONSHIP.QUIZZES_TO_BADGES}`,
      method: "get",
    });
    return data?.items[0].id;
  }
  return
};

export const getBadgeById = (badgeId) => {
  if(isSignedIn()) {
    return request({
      url: `${ENDPOINT.BADGES}/${badgeId}`,
      method: "get",
    });
  }
  return
};

export const getUserBadgesByUserId = async (userId) => {
  const pageSize = 20;
  const baseUrl = `${ENDPOINT.USER_BADGES}?filter=${RELATIONSHIP_FIELD.BADGES_IN_USER_BADGES} eq '${userId}'&pageSize=${pageSize}`;

  let items = [];
  let page = 1;
  let lastPage = 1;

  do {
    const response = await request({
      url: `${baseUrl}&page=${page}`,
      method: "get",
    });

    if (!Array.isArray(response?.items) || response.items.length === 0) {
      break;
    }

    items = items.concat(response.items);
    lastPage = response.lastPage ?? page;
    page++;
  } while (page <= lastPage);

  return { items, totalCount: items.length, lastPage };
};

export const getUserBadgeByUserIdAndQuizId = (quizId) => {
  return request({
    url: `${ENDPOINT.USER_BADGES}?filter=${RELATIONSHIP_FIELD.BADGES_IN_USER_BADGES} eq '${getCurrentUserId()}' and quizId eq ${quizId}`,
    method: "get",
  });
};
